import find from 'lodash/find';

export const transformWorkspaceResponse = ({
  id,
  name,
  createdBy,
  archived,
}) => ({
  id,
  name,
  archived,
  createdBy,
})

export const augmentWorkspacesWithUsers = (workspaces = [], users = []) => workspaces.map((workspace) => {
  const mappedObj = transformWorkspaceResponse(workspace);
  const owner = find(users, userData => userData.id === mappedObj.createdBy);

  return owner ? {
    ...mappedObj,
    owner
  } : mappedObj;
});
